<template>
  <input
    type="text"
    class="app-input-text"
    :style="{
      height: `${height}px`
    }"
    :value="text"
    @input="inputed"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: false,
      default: ''
    },
    height: {
      type: Number,
      required: false,
      default: 40
    }
  },
  data() {
    return {
      text: this.value
    }
  },
  methods: {
    inputed(e) {
      this.$emit('inputed', e.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.app-input-text {
  padding: 0 .5rem;
  width: 100%;
}
</style>